import { ContractData } from '@appTypes/essential-ui/ContractData';
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EUIDealsheetService } from '@services/essential-ui/eui-dealsheet/EUIDealsheetService';

export type ContractState = { contract: ContractData | null; loading: boolean; error: boolean };
const initiaContractState: ContractState = { contract: null, loading: false, error: false };

export const getContract = createAsyncThunk(
  'contract/getContract',
  async (params: { id: string; dealerId: string; chromeId: string }) => {
    try {
      const response = await EUIDealsheetService.getContract(
        params.id,
        params.dealerId,
        params.chromeId,
      );
      if (response) {
        return response;
      }
    } catch (err) {
      throw new Error('Failed to load contract');
    }
  },
);

const contractSlice = createSlice({
  name: 'contract',
  initialState: initiaContractState,
  reducers: {
    contractLoading(state) {
      state.contract = null;
      state.loading = true;
      state.error = false;
    },
    contractLoaded(state, action: PayloadAction<ContractData>) {
      state.contract = action.payload;
      state.loading = false;
      state.error = false;
    },
    contractError(state) {
      state.contract = null;
      state.loading = false;
      state.error = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContract.pending, (state) => {
        state.contract = null;
        state.loading = true;
        state.error = false;
      })
      .addCase(getContract.fulfilled, (state, action) => {
        if (action.payload) {
          state.contract = action.payload;
        }
        state.loading = false;
        state.error = false;
      })
      .addCase(getContract.rejected, (state) => {
        state.contract = null;
        state.loading = false;
        state.error = true;
      });
  },
});

export const { contractLoading, contractLoaded, contractError } = contractSlice.actions;

export default contractSlice.reducer;
